import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomPortal from '../../../../commonComponents/CustomPortal';
import { editUser, hideSuccessWorkerClassificationPopup, showRegistrationPopup } from '../../../../actions';

export const SuccessPopup = () => {
  const dispatch = useDispatch();
  const user = useSelector(
    (state) => state.user,
  );

  const handleConfirmButton = () => {
    if (!user?.user?.is_profile_complete) {
      dispatch(hideSuccessWorkerClassificationPopup());
      dispatch(editUser({ data: { is_profile_complete: true } }));
      dispatch(showRegistrationPopup());
    } else {
      window.location.reload();
    }
  };

  if (!user?.showSuccessWorkerClassificationPopup) return null;

  return (
    <CustomPortal
      isSuccess
      redirect={false}
      title="Worker Classification Successfully Selected!"
      text="This office’s worker classification selection has been confirmed. Congratulations, you are ready to start posting!"
      submitPressed={handleConfirmButton}
    />
  );
};
